// frontend/src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { Container, Form, Button, Alert, InputGroup, Spinner, Image } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AppLogo from "../assets/images/Planet Logo.jpg";

const Login = ({ setCurrentUser }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axiosClient.post("/auth/login", { username, password });
      console.log("Login response:", res.data);

      if (!res.data.token || !res.data.role || !res.data.userId) {
        setError("Invalid login response from server");
        setLoading(false);
        return;
      }

      // Save the current user in state (no localStorage)
      // setCurrentUser({
      //   userId: res.data.userId,
      //   username: res.data.username,
      //   role: res.data.role,
      //   token: res.data.token
      // });

      // Save to React state
    const user = {
      userId: res.data.userId,
      username: res.data.username,
      role: res.data.role,
      token: res.data.token,
      photo: res.data.photo || null
    };


      // Save to sessionStorage so axiosClient can use it
      sessionStorage.setItem("currentUser", JSON.stringify(user));

      setLoading(false);

      // Navigate based on role
      if (res.data.role === "admin") navigate("/admin/users");
      else if (res.data.role === "vip") navigate("/vip/dashboard");
      else setError("Unknown user role");

    } catch (err) {
      setError(err.response?.data?.message || "Invalid username or password");
      setLoading(false);
    }
  };

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh", maxWidth: "400px" }}
    >
      <div className="mb-4">
        <Image src={AppLogo} alt="App Logo" width={80} height={80} />
      </div>

      <h2 className="mb-4 text-center">Login</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit} className="w-100">
        <Form.Group className="mb-3">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <InputGroup>
            <Form.Control
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
            <Button
              variant="outline-secondary"
              onClick={() => setShowPassword(!showPassword)}
              type="button"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </Button>
          </InputGroup>
        </Form.Group>

        <Button type="submit" className="w-100" disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Logging in...
            </>
          ) : (
            "Login"
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default Login;
